<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Michael Quigley BA Hons 1st class MA, PGCE, is a former primary school teacher with extensive experience in teaching, coaching, mentoring and leadership. His company Kataholos has the mission of <em>growing people to be their best selves with clients all over the world</em>. Michael has a motivational podcast, <em>Food for the Journey</em>, as well as blogs and videos available to inspire and empower people from all walks of life. Michael loves to keep fit and play music, as well as travel and learn new skills.</p><br/>
<p style="text-indent:0em;"><em>Loving Leadership</em> is Michael’s second published book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4f0c2f77